export function insightsSectionSlider() {
    let $slider = $(".insights-slider");
    let slidesLength = $slider.find(".insight").length;
    let $navContainer = $(".insights-nav");
    let $currentSlideHolder = $(".current-slide");
    let $slidesLengthHolder = $(".slides-length");
    let $list = $(".scrolling-list");
    let $bigListItem  = $(".insights-list > .insight");
    let $win = $(window);
    let flag = false;

    let initSlider = function () {
        $slider.slick({
            slidesToShow: 1.2,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            infinite: false,
            nextArrow: `<button class="next" title="next button"><svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 9H19M19 9L10.6875 1M19 9L10.6875 17" stroke="#221C35" stroke-width="2"/>
                        </svg></button>`,
            prevArrow: `<button class="prev" title="prev button"><svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 9H19M19 9L10.6875 1M19 9L10.6875 17" stroke="#221C35" stroke-width="2"/>
                        </svg></button>`,
            appendArrows: $navContainer,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.8,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2.3,
                    }
                },
            ]
        }).on("afterChange", function (event, slick, currentSlide, nextSlide){
            $currentSlideHolder.text(currentSlide + 1);
        });

        $slidesLengthHolder.text(slidesLength);
    };

    if ($win.width() >= 1200) {
        $list.css({
            height: $bigListItem.height() + "px"
        });
    } else {
        initSlider();
    }

    $win.on("resize", function () {

        if ($win.width() < 1200 && !$slider.hasClass("slick-initialized")) {
            initSlider();
        } else {
            $list.css({
                height: $bigListItem.height() + "px"
            });
        }
    });

      $win.on("load", function () {
        $(".scrolling-list" ).mCustomScrollbar({
            axis: "y",
            autoDraggerLength: true,
            scrollInertia: 0,
            mouseWheel: {
                enable: true,
                preventDefault: true
            },
            scrollButtons: {
                enable: false
            }
        });

    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/insightsSectionSlider.js